﻿import React from 'react';

export const OneLineWrapper = (props) => {
  const wrappingClass = 'single-step__section-one-line-wrapper';

  return (
    <div className={wrappingClass}>
      {props.children}
    </div>
  )
}
